/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesPlanningDtosOvertimeAddOvertimeAdjustmentRequest,
  FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto,
  FacilityFlowCoreModulesPlanningDtosOvertimeSetUpOvertimeAccountRequest,
  GetApiV1EmployeesEmployeeIdOvertimeBalanceParams
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getEmployeeOvertime = () => {
/**
 * @summary Overtime account up to the end of the month containing referenceMonth
(the current month when omitted).
 */
const getApiV1EmployeesEmployeeIdOvertimeBalance = (
    employeeId: string,
    params?: GetApiV1EmployeesEmployeeIdOvertimeBalanceParams,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>(
      {url: `/api/v1/employees/${employeeId}/overtime-balance`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Put the account on a footing at go-live: the day it starts counting, plus the balance
carried over from the previous system. Everything before the start date stays out of
the account, so a tenant without imported time-clock history does not collect months of
time owed (ADR-0015).
 */
const postApiV1EmployeesEmployeeIdOvertimeAccountSetup = (
    employeeId: string,
    facilityFlowCoreModulesPlanningDtosOvertimeSetUpOvertimeAccountRequest: FacilityFlowCoreModulesPlanningDtosOvertimeSetUpOvertimeAccountRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>(
      {url: `/api/v1/employees/${employeeId}/overtime-account/setup`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosOvertimeSetUpOvertimeAccountRequest
    },
      options);
    }
  /**
 * @summary Book a manual correction onto the account. Appends to the log — a previous correction
is never overwritten, so the account stays explainable.
 */
const postApiV1EmployeesEmployeeIdOvertimeAdjustments = (
    employeeId: string,
    facilityFlowCoreModulesPlanningDtosOvertimeAddOvertimeAdjustmentRequest: FacilityFlowCoreModulesPlanningDtosOvertimeAddOvertimeAdjustmentRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>>,) => {
      return customInstance<FacilityFlowCoreModulesPlanningDtosOvertimeOvertimeBalanceDto>(
      {url: `/api/v1/employees/${employeeId}/overtime-adjustments`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesPlanningDtosOvertimeAddOvertimeAdjustmentRequest
    },
      options);
    }
  return {getApiV1EmployeesEmployeeIdOvertimeBalance,postApiV1EmployeesEmployeeIdOvertimeAccountSetup,postApiV1EmployeesEmployeeIdOvertimeAdjustments}};
export type GetApiV1EmployeesEmployeeIdOvertimeBalanceResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployeeOvertime>['getApiV1EmployeesEmployeeIdOvertimeBalance']>>>
export type PostApiV1EmployeesEmployeeIdOvertimeAccountSetupResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployeeOvertime>['postApiV1EmployeesEmployeeIdOvertimeAccountSetup']>>>
export type PostApiV1EmployeesEmployeeIdOvertimeAdjustmentsResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getEmployeeOvertime>['postApiV1EmployeesEmployeeIdOvertimeAdjustments']>>>
